/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AutoPayRequest } from '../models/AutoPayRequest';
import type { AutoPayResponse } from '../models/AutoPayResponse';
import type { CreditCardTypeEnum } from '../models/CreditCardTypeEnum';
import type { PaymentTypeEnum } from '../models/PaymentTypeEnum';
import type { RefundCreate } from '../models/RefundCreate';
import type { TransactionDetails } from '../models/TransactionDetails';
import type { VoidCreate } from '../models/VoidCreate';
import { request as __request } from '../core/request';

export class PaymentsVService {

    /**
     * @param districtId
     * @param paymentType
     * @param amount
     * @param ccType
     * @returns number OK
     * @throws ApiError
     */
    public static async paymentsVGetServiceFee(
        districtId: string,
        paymentType: PaymentTypeEnum,
        amount: number,
        ccType?: CreditCardTypeEnum,
    ): Promise<number> {
        const result = await __request({
            method: 'GET',
            path: `/api/v3/payments/service-fee`,
            query: {
                'DistrictId': districtId,
                'PaymentType': paymentType,
                'Amount': amount,
                'CCType': ccType,
            },
        });
        return result.body;
    }

    /**
     * @param transactionId
     * @param requestBody
     * @returns TransactionDetails Created
     * @throws ApiError
     */
    public static async paymentsVVoidTransaction(
        transactionId: string,
        requestBody?: VoidCreate,
    ): Promise<TransactionDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v3/payments/${transactionId}/void`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @param transactionId
     * @param requestBody
     * @returns TransactionDetails Created
     * @throws ApiError
     */
    public static async paymentsVRefundTransaction(
        transactionId: string,
        requestBody?: RefundCreate,
    ): Promise<TransactionDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v3/payments/${transactionId}/refund`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns AutoPayResponse Created
     * @throws ApiError
     */
    public static async paymentsVBulkPayment(
        requestBody?: Array<AutoPayRequest>,
    ): Promise<Array<AutoPayResponse>> {
        const result = await __request({
            method: 'POST',
            path: `/api/v3/payments/autopay/bulk`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @param startDate
     * @param endDate
     * @returns TransactionDetails OK
     * @throws ApiError
     */
    public static async paymentsVGetMissing(
        startDate?: string,
        endDate?: string,
    ): Promise<Array<TransactionDetails>> {
        const result = await __request({
            method: 'GET',
            path: `/api/v3/payments/missing`,
            query: {
                'StartDate': startDate,
                'EndDate': endDate,
            },
        });
        return result.body;
    }

}